export const customReportStatus = {
  STATUS_CREATED: 1,
  STATUS_STARTED: 2,
  STATUS_SUCCEEDED: 3,
  STATUS_FAILED: 4,
};

export const customReportInputTypes = {
  TYPE_DROPDOWN: 'TYPE_DROPDOWN',
  TYPE_PAYROLL_MONTH: 'TYPE_PAYROLL_MONTH',
  TYPE_PAYROLL_DATE: 'TYPE_PAYROLL_DATE',
  TYPE_FINANCIAL_YEAR: 'TYPE_FINANCIAL_YEAR',
};

/**
 * Reserved framework-level filter key (never part of a report's declared
 * filters): comma-separated people ids resolved by the custom-field filter.
 * A present-but-empty value means "filter active, zero matches".
 */
export const HRIS_PEOPLE_IDS_FILTER_KEY = 'hris_people_ids';

/** How long a queued (non-real-time) report may run before we show the "high demand" alert. */
export const REPORT_QUEUE_ALERT_THRESHOLD_MS = 1000 * 60 * 5; // 5 minutes

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50];

export const customReportFilterTypes = {
  TYPE_FILTER_SEARCH_PEOPLE_BY_NAME: 'TYPE_FILTER_SEARCH_PEOPLE_BY_NAME',
  TYPE_FILTER_SEARCH_PEOPLE_BY_EMAIL: 'TYPE_FILTER_SEARCH_PEOPLE_BY_EMAIL',
  TYPE_FILTER_SEARCH_PEOPLE_BY_ID: 'TYPE_FILTER_SEARCH_PEOPLE_BY_ID',
};
